export default __webpack_public_path__ + "static/media/Yamaichi.f02084a2.svg";